import { DateTime } from 'luxon'

export enum StorefrontMetricsActionTypes {
  SET_STOREFRONT_METRICS_DATA = 'SET_STOREFRONT_METRICS_DATA',
  CLEAR_STOREFRONT_METRICS_DATA = 'CLEAR_STOREFRONT_METRICS_DATA',
  SET_STOREFRONT_METRICS_DOMAIN = 'SET_STOREFRONT_METRICS_DOMAIN',
  SET_STOREFRONT_METRICS_PRODUCT = 'SET_STOREFRONT_METRICS_PRODUCT',
  SET_DATE_RANGE = 'SET_DATE_RANGE',
}

export type StatRiseType = 'up' | 'down'
export interface ImpressionCount {
  totalCount?: number
  percentage?: number
  key?: string
}
export interface ButtonsRecords {
  clicks?: number
  clickPercentage?: number
  formSubmissionPercentage?: number
  formSubmission?: number
  key: string
}
export interface TrafficSource {
  ref?: string
  count?: number
  percentage?: number
}
export interface TrafficSourceData {
  top3?: TrafficSource[]
  otherTrafficSource?: TrafficSource[]
}

export interface InteractionsData {
  id: string
  data: { date: string; value: number }[]
}
export interface DateRange {
  startDate: string
  endDate: string
}

export interface MetricsData {
  impressionCount: ImpressionCount[]
  buttonRecords: ButtonsRecords[]
  trafficSource: TrafficSourceData
  campaignsEfficiency: CampaignEfficiency[]
  domain?: string
  graphData?: InteractionsData[]
  domainNames?: string[]
  selectedProduct: any
  productOptions: []
  dateRange: DateRange
  mapData: any
}
export interface CampaignEfficiency {
  count: number
  name: string
  percentage: number
  otherCampaignsCounts?: CampaignEfficiency[]
}

export const initialStorefrontMetricsState: MetricsData = {
  impressionCount: [],
  buttonRecords: [],
  trafficSource: {},
  campaignsEfficiency: [],
  domain: 'All domains',
  selectedProduct: 'allListings',
  graphData: [],
  domainNames: [],
  productOptions: [],
  dateRange: {
    startDate: DateTime.now().minus({ months: 6 }).toISODate() as string,
    endDate: DateTime.now().toISODate() as string,
  },
  mapData: {},
}

export type StorefrontMetricsAction =
  | {
      type: StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_DATA
      payload: MetricsData
    }
  | {
      type: StorefrontMetricsActionTypes.CLEAR_STOREFRONT_METRICS_DATA
    }
  | {
      type: StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_DOMAIN
      payload: string
    }
  | {
      type: StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_PRODUCT
      payload: string
    }
  | {
      type: StorefrontMetricsActionTypes.SET_DATE_RANGE
      payload: DateRange
    }
